/**
 *
 * Asynchronously loads the component for EventMemberTags
 *
 */

import loadable from '../../utils/loadable';
import TagWidgetSkeleton from '../common/skeletons/TagWidgetSkeleton';

export default loadable(() => import('./index'), {
  fallback: TagWidgetSkeleton,
});
